<!-- 업체 선택용 공통 팝업 -->
<template>

  <v-container>
    <v-row dense no-gutters>
      <v-col cols="12" class="d-flex justify-center">
        <v-btn class="white_blue_fullbtn" style="width:90%" elevation="0" outlined large @click="showpopup_com" >{{$t('cdstepdialog_label1')}}</v-btn>
      </v-col>
    </v-row>
    <v-row>

      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_com" @keydown.esc="close_com" fullscreen>
        <v-card class="dialog_round pa-2">
        <v-card-text>
        <v-container fluid>

          <v-row dense no-gutters>

            <v-col cols="5">
              <v-row align="center">
                <v-col cols="4">
                  <span class="dialog_title">{{$t('cdstepdialog_label1')}}</span>
                </v-col>
                <v-col cols="4">
                    <v-text-field 
                      dense single-line clearable
                      @keyup.enter="search_run" 
                      v-model="search_keyword" 
                      :placeholder="$t('common_search_keywrod')"
                      outlined height="43"
                      color="#808080"
                      hide-details
                      />
                </v-col>
                <v-col cols="2">
                    <v-btn class="search_btn" elevation="0" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers"
                :items="items"
                v-model="select_com"
                :no-data-text="$t('design_msg11')"
                :no-results-text="$t('design_msg12')"
                hide-default-footer
                class="datatablestyle ml-5 mr-5"
                :items-per-page="pagerow"
                item-key="IDX"
                :loading="loading"
                >
                <template v-slot:header.EVENT_NAME>
                  <label class="cheader_normal" >{{$t("cdstepdialog_col1")}}</label>
                </template>
                <template v-slot:header.COMPONENT_WIDTH>
                  <label class="cheader_normal" >{{$t("cdstepdialog_col2")}}</label>
                </template>
                <template v-slot:header.COMPONENT_HEIGHT>
                  <label class="cheader_normal" >{{$t("cdstepdialog_col3")}}</label>
                </template>
                <template v-slot:header.STEP_NAME>
                  <label class="cheader_normal" >{{$t("cdstepdialog_col4")}}</label>
                </template>

                <template v-slot:item.EVENT_NAME="{ item }">
                  <a @click="loaddetail_com(item)">{{item.EVENT_NAME}}</a>
                </template>
              </v-data-table>

              <v-col cols="12" md="12" class="d-flex justify-center">
                    <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
                    <span v-for="n in subpage" :key="n.id">
                        <span v-if="page == bottompage-1+n">
                            <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
                        </span>
                        <span v-else>
                            <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
                        </span>
                    </span>
                    <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
              </v-col>

            </v-col>

            <v-col cols="7">
                <v-col cols="12" md="12" sm="12" xs="12">
                  <v-btn class="dialog_cancel_btn mr-2" rounded large @click="close_com">{{$t("common_close")}}</v-btn>
                  <v-btn class="dialog_btn" rounded large @click="save_com">{{$t('common_select')}}</v-btn>
                </v-col>

                <v-row justify="center" >
                  <div id="edit_div_step" :style="'width:'+DISPLAY_WIDTH+'px;height:'+DISPLAY_HEIGHT+'px;backgroundColor:#808080;overflow:hidden;position:absolute;border:solid 2px red;'">
                  </div>
                  <div id="edit_div_step2" :style="'margin-top:'+(DISPLAY_HEIGHT+40)+'px;width:'+DISPLAY_WIDTH+'px;height:'+DISPLAY_HEIGHT+'px;backgroundColor:#808080;overflow:hidden;position:absolute;border:solid 2px red;'">
                  </div>
                </v-row>

            </v-col>
          </v-row>

        </v-container>
      
      </v-card-text>
      </v-card>
      </v-dialog>     

    </v-row>

  </v-container>
  
</template>

<script>
// eslint-disable-next-line no-unused-vars
import DRBackground from '../dragndrop/DRBackground.js'
import DRComponent from '../dragndrop/DRComponent.js'
import DRModel from '../dragndrop/DRModel.js'

    export default {

        data: ()=> ({
            useInfo:{},
            
            //dr background
            stdrback: null,
            stdrback2: null,

            dialog_com : false,
            load_flag : false,

            //필수 페이징 파라메터
            totalcnt : 0,       //전체 아이템 개수
            page : 0,
            maxpage : 0,        //전체 페이지 개수
            startpage : 1,      //시작 인덱스
            bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
            subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
            loading : false,    //로딩 표시
            pagerow : 20,

            headers: [
              {text: '행사명', align: 'center', sortable: false, value: 'EVENT_NAME', width:"300px"},
              {text: '너비', align: 'center', sortable: false, value: 'COMPONENT_WIDTH'},
              {text: '높이', align: 'center', sortable: false, value: 'COMPONENT_HEIGHT'},
              {text: '관계자구분', align: 'center', sortable: false, value: 'STEP_NAME'},
            ],
            search_type : 'NAME',   
            search_keyword : '',
            PARENT_ITEM: {},
            items: [],
            itemList_com: [],
            select_com:[],
            MATCHTYPELIST: [],        

            DISPLAY_WIDTH:384,
            DISPLAY_HEIGHT:463,

        }),

        updated(){
          
          if(this.dialog_com){
            if(!this.load_flag && this.items.length == 0 && this.search_keyword.length == 0){
              this.load_flag = true;
              this.loadpage(1);
            }
          }else{
            //팝업이 닫히면
            this.load_flag = false;
          }

        },

        methods: {
            //DRBackground가 호출함. 무조건 있어야함.
            colorupdate(){

            },

            //검색
            search_run(){
              this.loadpage(1);
            },

            prev(){
                this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
                this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
                var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
                this.loadpage(temp_page);
            },
            next(){
                this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
                this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
                var temp_page = this.bottompage;
                this.loadpage(temp_page);
            },

            makepaging(){
              var div1 = this.totalcnt / this.pagerow; 
              var div2 = this.totalcnt % this.pagerow;
              if(div2 == 0){  
                  this.maxpage = parseInt(div1);    
              }else{
                  this.maxpage = parseInt(div1+1);
              }
              if(this.bottompage == 1){
                this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
              }
            },

            createComponent(bg, list){

              //컴포넌트 생성
              list.forEach(element => {
                
                const model = new DRModel();
                model.ADMIN_IDX     = element.ADMIN_IDX;
                model.EVENT_IDX     = element.EVENT_IDX;
                model.STEP_IDX      = element.STEP_IDX;
                model.IMG           = element.IMG;
                model.LOCALIMG      = null;
                model.ISBG          = element.ISBG;
                model.ISFLIP        = element.ISFLIP;
                model.BGTYPE        = element.BGTYPE;
                model.BGCOLOR       = element.BGCOLOR;
                model.TEXTCOLOR     = element.TEXTCOLOR;
                model.TEXTSIZE      = element.TEXTSIZE;
                model.TEXTFONT      = element.TEXTFONT;
                model.TEXTVALUE     = element.TEXTVALUE;
                model.TEXTALIGN     = element.TEXTALIGN;
                model.TEXTMATCH     = element.TEXTMATCH;
                model.LAYOUT_WIDTH  = parseInt(element.LAYOUT_WIDTH);
                model.LAYOUT_HEIGHT = parseInt(element.LAYOUT_HEIGHT);
                model.LAYOUT_POSX   = parseInt(element.LAYOUT_POSX);
                model.LAYOUT_POSY   = parseInt(element.LAYOUT_POSY);
                model.ROTATE        = element.ROTATE || 0;
                
                model.TEMP_POSX   = model.LAYOUT_POSX;
                model.TEMP_POSY   = model.LAYOUT_POSY;
                model.TEMP_WIDTH  = model.LAYOUT_WIDTH;
                model.TEMP_HEIGHT = model.LAYOUT_HEIGHT;

                model.ZINDEX        = element.ZINDEX;
                model.COMPONENT_TYPE = element.COMPONENT_TYPE;

                //새롭게 타입이 추가됨. 기존에 만들어진 디자인의 경우 호환을 위해 강제로 1처리 = TEXT
                if(element.ISBG == undefined || element.ISBG == null){
                  if(element.LAYOUT_WIDTH == 384 && element.LAYOUT_POSX == 0 && element.LAYOUT_POSY == 0){
                    model.ISBG = 1; //bg
                    //bg는 this.drback에 직접 처리
                    bg.updateBackground(model);
                    return;
                  }else{
                    model.ISBG = 0;
                    if(element.COMPONENT_TYPE == undefined || element.COMPONENT_TYPE == null){
                      if(element.TEXTVALUE != null && element.TEXTVALUE.length > 0){
                        model.COMPONENT_TYPE = 1; //text
                      }else{
                        model.COMPONENT_TYPE = 0; //image
                      }
                    }
                  } 
                }

                if(element.ISBG == 1){
                    bg.updateBackground(model);
                    return;
                }

                //컴포넌트 객체 생성.
                const component = new DRComponent(model, this.MATCHTYPELIST, false);
                bg.addComponent(component);

              });

            },
            loadpage(p){

                this.loading = true;
                this.page = p;

                this.$http.post(this.$host+'/api/DesignStepList',
                  {
                      ADMIN_IDX : this.$session.get("ADMIN_IDX")
                    , COM_IDX : this.$session.get("COM_IDX")
                    , search_type:this.search_type
                    , search_keyword: escape(this.search_keyword)
                    , page: this.page
                    , pagerow: this.pagerow
                  },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
                .then((result)=>{
                  this.load_flag = true;
                  this.loading = false;
                  if(result.data.resultCode == 0){

                    //토큰 저장
                    if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                      this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                    }
                    if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                      this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                    }

                    this.totalcnt = result.data.totalcnt;
                    this.makepaging();
                    const list = result.data.resultData;
                    this.items.splice(0, this.items.length);   //데이터 초기화
                    list.forEach(element => {
                        this.items.push(element); 
                    });

                  }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                  }
                  this.loading = false;
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                    this.loading = false;
                });

            },

            loaddetail_com(item){
              this.PARENT_ITEM = item;
              //맵핑을 위한 행사입력양식 조회
              this.MATCHTYPELIST.splice(0, this.MATCHTYPELIST.length);   
              this.$http.post(this.$host+'/api/InputEventList',{
                    ADMIN_IDX : this.$session.get("ADMIN_IDX")
                  , COM_IDX : this.$session.get("COM_IDX")
                  , EVENT_IDX : item.EVENT_IDX
              },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
              .then((result)=>{
                if(result.data.resultCode == 0){
                    //토큰 저장
                    if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                      this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                    }
                    if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                      this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                    }

                    try{
                      this.useInfo = result.data.useData;
                      const list = result.data.resultData;
                      this.MATCHTYPELIST.push({name:this.$i18n.locale == 'ko' ? '직접입력' : 'Input', value:"INPUT"});
                      list.forEach(element => {
                          this.MATCHTYPELIST.push({name:element.NAME, value:element.INPUT_CODE}); 
                      });

                      this.PARENT_ITEM = item;
                      var edit_div1 = document.getElementById("edit_div_step");
                      var edit_div2 = document.getElementById("edit_div_step2");
                      while(edit_div1.hasChildNodes()){
                        edit_div1.removeChild(edit_div1.firstChild ); 
                      }
                      while(edit_div2.hasChildNodes()){
                        edit_div2.removeChild(edit_div2.firstChild ); 
                      }

                      this.DISPLAY_WIDTH  = item.COMPONENT_WIDTH;
                      this.DISPLAY_HEIGHT = item.COMPONENT_HEIGHT;

                      const bg = new DRModel();
                      bg.LAYOUT_WIDTH   = this.DISPLAY_WIDTH;
                      bg.LAYOUT_HEIGHT  = this.DISPLAY_HEIGHT;
                      bg.LAYOUT_POSX    = 0;
                      bg.LAYOUT_POSY    = 0;
                      bg.ISBG           = 1;  //bg
                      bg.COMPONENT_TYPE = 0; 
                      bg.BGTYPE = 0;
                      bg.BGCOLOR = "FFFFFFFF";
                      this.stdrback  = new DRBackground(bg, [], this, true);
                      this.stdrback2 = new DRBackground(bg, [], this, false);
                      edit_div1.appendChild(this.stdrback.back_div);
                      edit_div2.appendChild(this.stdrback2.back_div);

                      this.stdrback.clearBackground();
                      this.stdrback2.clearBackground();
                      this.createComponent(this.stdrback,  item.COMPONENT.data);
                      this.createComponent(this.stdrback2, item.COMPONENT2.data);

                    }catch(e){
                      //console.log("error list..." + JSON.stringify(e));
                    }


                }else if(result.data.resultCode == 2){
                  //로그인 필요
                  this.$alert(this.$t("common_tokener"));
                  this.$session.clear("ADMIN_IDX");
                  this.$session.clear("COM_IDX");
                  this.$session.clear("ACNT_IDX");
                  this.$session.clear("GRADE");
                  this.$session.clear("COM_NAME");
                  this.$session.clear("ACCESSTOKEN");
                  this.$session.clear("REFLASHTOKEN");
                  this.$router.push('Login');   //로그인 페이지로 이동
                }
              })
              // eslint-disable-next-line no-unused-vars
              .catch((error)=>{
                if(error.message == 'Request failed with status code 429')
                {
                  this.$alert(this.$t("common_reqer"));
                }else{
                  this.$alert(error.message);
                }
              });

            },

            //다이얼로그 닫기
            close_com () {
                this.dialog_com = false
                this.select_com = [];
                this.items.splice(0, this.items.length);   //데이터 초기화
                this.search_keyword = '';
                //BG초기화
                const edit_div = document.getElementById("edit_div_step");
                while ( edit_div.hasChildNodes() ) {
                  edit_div.removeChild( edit_div.firstChild ); 
                }
                const edit_div2 = document.getElementById("edit_div_step2");
                while ( edit_div2.hasChildNodes() ) {
                  edit_div2.removeChild( edit_div2.firstChild ); 
                }
            },

            //추가 저장
            save_com () {

              if(this.PARENT_ITEM.ADMIN_IDX == null || this.PARENT_ITEM.ADMIN_IDX == undefined){
                this.$alert(this.$t('clayoutdialog_label3'));
                return;
              }

              this.$confirm(this.$t('clayoutdialog_label4'))
              .then(() => {
                this.$emit('callback', this.PARENT_ITEM)
                //콜백 호출 후 닫아야함.
                this.dialog_com = false
                this.select_com = [];
                this.items.splice(0, this.items.length);   //데이터 초기화
                this.search_keyword = '';
                //BG초기화
                const edit_div = document.getElementById("edit_div_step");
                while ( edit_div.hasChildNodes() ) {
                  edit_div.removeChild( edit_div.firstChild ); 
                }
                const edit_div2 = document.getElementById("edit_div_step2");
                while ( edit_div2.hasChildNodes() ) {
                  edit_div2.removeChild( edit_div2.firstChild ); 
                }
              });
            },      

            showpopup_com(){
              this.dialog_com = true;
              this.load_flag = false;
            },


        }

    }
</script>

<style scoped>

</style>